SupportMainContentWrapperView = require('../../main_content_view')
StepTwoCMSBaseView = require('./base_view')
Mustache = require('../../../../../../core/frontend/vendor_modules/mustache-0.7.2')

class StepTwoV2CMSView extends StepTwoCMSBaseView
  initialize: ->
    StepTwoCMSBaseView::initialize.apply(this, arguments)

  render: ->
    StepTwoCMSBaseView::render.call(this)
    mainContentWrappper = new SupportMainContentWrapperView
    mainContentWrappper.render( (contentWrapper) =>
      @fetchFlexibleContactChannels(contentWrapper)
      @fetchAndRenderCategory(contentWrapper)
    )
    @$el.append(mainContentWrappper.el)
    @renderStepTwoActions()
    content = Groupon.Support.ContentModel.getContent()
    @renderContent(content) if content?

  renderContent : (content) ->
    unless content?.text? && content.text isnt ""
      @helpContentLoadError()
      return
    text = Mustache.to_html(content.text, Groupon.Support.ContentModel.getContentObject())
    category_id = @getCategoryId()
    sub_category_id = @getSubCategoryId()
    attributeValue = "hw__#{country.name}__#{category_id}__#{sub_category_id}__#{content.id}"
    @renderContentData(text, attributeValue)
    @enableStepActions()

  clearContentElement: ->
    @clearElement('.cms-content')
    @$('.content-section').hide()
    @clearStepThreeIfPresent()

  clearStepThreeIfPresent: ->
    if Groupon.Support.CURRENTVIEW? && Groupon.Support.CURRENTVIEW.id isnt @id
      Groupon.Support.HelpWizardViewManager.removeStackedViewsAndUpdateCurrentView(this)
      propagateEventBeforeReplacingElements( -> Backbone.history.navigate("#select-issue", {trigger: false}))

  renderCategory: (contentWrapper)->
    @categoryRendered = true
    contentWrapper.html toHtml(@categoryTemplate, {categories: @getCategoryList(), isFilterDropdowns: true, showVerticalPageFlow: true}, @I18nScope)
    contentCategory = Groupon.Support.ContentModel.getCategory()
    if contentCategory && contentCategory != null
      $(".category", contentWrapper).val(contentCategory.id)
      # Adding single Quotes because the jquery selector erroring out if the id has punctuation in it
      $(".category option[value='#{contentCategory.id}']", contentWrapper).attr("selected", "selected")
      @renderSubCategory(contentWrapper)

  enableStepActions: ->
    @handleDisplayOfTicketDirectionButtons()

  helpContentSuccess: (results) =>
    @spinnerView.hide()
    content = @resolveContent(results)
    Groupon.Support.ContentModel.flexibleStepThree = @resolveFlexStepThree results
    @setPriorityContentFlags(results)
    Groupon.Support.ContentModel.setContent(content)
    @renderContent(content)

  helpContentLoadError: ->
    @spinnerView.hide()
    category_id = @getCategoryId()
    sub_category_id = @getSubCategoryId()
    @clearElement('.cms-content')
    @$('.content-section').hide()
    @disableAllButton()
    Backbone.history.navigate('#contact-us', {trigger: true})

  renderContentData: (text, attributeValue)->
    @$('.inbenta-content').empty()
    @$('.content-section').show()
    @$('.cms-content').attr("data-bhw", attributeValue)
    @$('.cms-content').html(text)

  helpContentError: () =>
    Groupon.Support.ContentModel.flexibleStepThree = null
    Groupon.Support.ContentModel.setContent(null)
    @helpContentLoadError()

  filterDropdowns: (dropdowns, allTags) ->
    _.filter dropdowns, (item) =>
      return true unless item.tagLines?
      _.some item.tagLines, (tl) =>
        filterTags = tl.split ","
        commonTags = _.intersection allTags, filterTags
        commonTags.length == allTags.length

  getCategoryList:() ->
    dropdowns = @getDropdowns()
    dropdowns = @addTaglinesToCategories(dropdowns)
    if @tagLine?
      allTags = @tagLine.split ","
      dropdowns = @filterDropdowns(dropdowns, allTags)
    _.sortBy dropdowns, (category) ->
      parseInt category.weight

  getSubCategoryList: () ->
    dropdowns = @getDropdowns()
    category = _.find dropdowns, (item) -> item.id == Groupon.Support.ContentModel.getCategory().id
    subCategories = category.subCategories
    if @tagLine?
      allTags = @tagLine.split ","
      subCategories = @filterDropdowns(subCategories, allTags)
    _.sortBy subCategories, (s) ->
      parseInt s.weight

  addTaglinesToCategories: (dropdowns) ->
    _.each dropdowns, (category) ->
      categoryTaglines = []
      _.each category.subCategories, (subCategory) ->
        categoryTaglines.push(subCategory.tagLines)
      categoryTaglines = _.uniq(_.flatten categoryTaglines)
      category.tagLines = categoryTaglines
    dropdowns

  shouldFetchFlexibleContactChannels: ()->
    not @flexibleContactChannelModel.hasContactChannels()

module.exports = StepTwoV2CMSView
